import { r4Client, r4Error } from '@/services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('UserStore')

const userParams = payload => {
  return payload
}

const UserStore = {
  namespaced: true,
  state: {
    users: [],
    user: {}
  },
  mutations: {
    saveUsers: (state, payload) => (state.users = payload.data),
    saveUser: (state, payload) => {
      // handle cases were coming from API (.data) and from setting directly from list
      if (!payload) {
        state.user = {}
      } else if (payload.data) {
        state.user = payload.data
      } else {
        state.user = payload
      }
    },
    resetUser: state => {
      state.user = {}
    }
  },
  actions: {
    fetchUsers ({ state, commit }) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/users')
          .then(response => {
            commit('saveUsers', response.data)
            resolve(state.users)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    createUser ({ state, commit }, payload) {
      const userData = userParams(payload)
      return new Promise((resolve, reject) => {
        r4Client()
          .post('/api/v1/users', userData)
          .then(response => {
            logger.trace('CreateUser: Success')
            commit('saveUser', response.data)
            resolve(state.user)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    updateUser ({ state, commit }, payload) {
      const userData = userParams(payload)
      return new Promise((resolve, reject) => {
        r4Client()
          .put(`/api/v1/users/${payload.id}`, userData)
          .then(response => {
            logger.trace('UpdateUser: Success')
            commit('saveUser', response.data)
            resolve(state.user)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    // determines if create or update should be used
    saveUser ({ dispatch }, payload) {
      if (payload.id) {
        return dispatch('updateUser', payload)
      } else {
        return dispatch('createUser', payload)
      }
    },
    getUser ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        return r4Client()
          .get(`/api/v1/users/${payload.id}`)
          .then(response => {
            commit('saveUser', response.data)
            resolve(state.user)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    setCurrentUserByUserId ({ state, commit, dispatch }, payload) {
      const targetUserId = payload.id
      const fetchUsersPromise = state.users.length === 0 ? dispatch('fetchUsers') : Promise.resolve()

      fetchUsersPromise.then(() => {
        const user = state.users.find(d => {
          return d.id === targetUserId
        })
        commit('saveUser', user)
      })
    },
    enableUser ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        return r4Client()
          .put(`/api/v1/users/${payload.id}/enable`)
          .then(response => {
            commit('saveUser', response.data)
            resolve(state.user)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    disableUser ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        return r4Client()
          .put(`/api/v1/users/${payload.id}/disable`)
          .then(response => {
            commit('saveUser', response.data)
            resolve(state.user)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    }
  },
  getters: {}
}

export default UserStore
